<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="12">
            <b-card class="col-12">
              <b-row>
                <h4 class="text-primary col-12">Add picture</h4>

                <b-col cols="12" md="6">
                  <template>
                    <b-avatar
                      ref="previewEl"
                      :src="base64ImageSrc"
                      class="cursor-pointer"
                      rounded
                      size="150px"
                      @click.native="$refs.refInputEl.click()"
                    >
                      <feather-icon
                        v-if="base64ImageSrc === null"
                        icon="PlusSquareIcon"
                        size="100"
                      />
                    </b-avatar>
                  </template>
                  <b-button
                    class="mt-2 mb-sm-0 mr-2 col-12 col-md-5 d-none"
                    variant="warning"
                    @click="$refs.refInputEl.click()"
                  >
                    <input
                      ref="refInputEl"
                      accept=".jpg,.jpeg,.png,.svg"
                      class="d-none"
                      type="file"
                      @input="setCover($event)"
                    />
                  </b-button>
                </b-col>

                <b-col cols="12" class="my-1">
                  <b-button
                    :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                    class="col-12 col-md-2"
                    variant="primary"
                    @click="uploadPicture"
                  >
                    Save
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-card v-if="medias.length > 0">
          <h2 class="text-primary mb-2">Medias</h2>
          <b-row>
            <b-col
              v-for="(image, idx) in medias"
              class="d-flex flex-column"
              md="2"
            >
              <b-avatar
                ref=" previewEl"
                :src="baseUrl + image.pictureUrl"
                class="mx-auto"
                rounded
                size="200px"
              ></b-avatar>
              <b-col cols="12" class="my-1">
                <b-button
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  class="col-12"
                  variant="danger"
                  @click="deletePicture(image.mediaId)"
                >
                  Delete
                </b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BAlert,
  BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BImg,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Helper from "@/libs/Helper";
import { required } from "@validations";
import {
  CategoryPropertyGroupGetBy,
  ProductCategoriesGetSubCategories,
} from "@/libs/Api/ProductCategory";
import LanguagePicker from "@/views/components/utils/LanguagePicker.vue";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import { GetAllLangs } from "@/libs/Api/Language";
import { ShipmentGetAll } from "@/libs/Api/Shipment";
import ckEditorMain from "@/views/components/ckEditorMain.vue";
import ProductCategoryProperty from "@/views/apps/product/ProductCategoryProperty.vue";
import {
  ProductCreate,
  ProductDeleteProductImageByMediaId,
  ProductGetAll,
  ProductGetBy,
  ProductGetById,
  ProductGetProductImageByMainId,
  ProductUpdatePrice,
  ProductUpdatePriceByMainId,
} from "@/libs/Api/Product";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { UnitsGetAll } from "@/libs/Api/Units";
import { CurrenciesCreate, CurrenciesGetAll } from "@/libs/Api/Currencies";
import { OrderCreateByAdmin } from "@/libs/Api/Order";
import { MediaSaveImagesWithWatermark, MediaUpload } from "@/libs/Api/Media";

export default {
  title: "Product Images",
  data() {
    return {
      required,
      baseUrl: Helper.baseUrl,
      mainId: this.$route.params.mainId,
      overlay: false,
      medias: [],
      count: 10,
      pageNumber: 1,
      totalCount: null,
      base64ImageSrc: null,
    };
  },
  async created() {
    await this.getAllProductMedia();
  },
  methods: {
    async getAllProductMedia() {
      try {
        this.overlay = true;
        let _this = this;
        let qParams = {
          MainId: _this.$route.params.mainId,
        };
        let productGetProductImageByMainId = new ProductGetProductImageByMainId(
          _this
        );
        productGetProductImageByMainId.setParams(qParams);
        await productGetProductImageByMainId.fetch((response) => {
          if (response.isSuccess) {
            _this.medias = response.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.overlay = false;
      }
    },
    async uploadPicture() {
      let _this = this;
      _this.overlay = true;
      let file = _this.$refs.refInputEl.files.item(0);
      let formData = new FormData();
      formData.append("Files", file);
      let mediaSaveImagesWithWatermark = new MediaSaveImagesWithWatermark(
        _this
      );
      mediaSaveImagesWithWatermark.setParams({
        objectId: _this.mainId,
        withWatermark: true,
      });
      mediaSaveImagesWithWatermark.setFormPrams(formData);
      await mediaSaveImagesWithWatermark.sendFormData(
        (content) => {
          _this.overlay = false;
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `Operation successful`,
              icon: "CheckIcon",
              variant: "success",
            },
          });
          window.location.reload();
        },
        (error) => {
          _this.overlay = false;
          console.log(error);
        }
      );
    },
    async deletePicture(id) {
      let _this = this;
      _this.overlay = true;

      let productDeleteProductImageByMediaId =
        new ProductDeleteProductImageByMediaId(_this);
      productDeleteProductImageByMediaId.setParams({ mediaId: id });
      await productDeleteProductImageByMediaId.fetch(
        (conetnt) => {
          _this.overlay = false;
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `Operation successful`,
              icon: "CheckIcon",
              variant: "success",
            },
          });
          _this.getAllProductMedia();
        },
        (error) => {
          console.log(error);
          _this.overlay = false;
        }
      );
    },
    setCover(e) {
      let file = e.target.files[0];
      this.base64ImageSrc = URL.createObjectURL(file);
    },
  },
  components: {
    ckEditorMain,
    AddEditDeleteButton,
    LanguagePicker,
    BModal,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    vSelect,
    BTable,
    BPagination,
    ValidationObserver,
    ValidationProvider,
    ProductCategoryProperty,
  },
};
</script>

<style>
.modal-header > .close {
  display: none !important;
}
</style>
